/* eslint-disable import/prefer-default-export */
import { formatHex, parse } from 'culori';
import twColors from 'tailwindcss/colors';

function twHex(color) {
  if (typeof color !== 'string') return color;
  if (!color.startsWith('oklch(')) return color;

  const parsed = parse(color);
  if (!parsed) return color;

  return formatHex(parsed);
}

const primaryTextColor = twHex(twColors.gray[900]);

/**
 * Custom typography scale.
 * - hero, title, subtitle — page/section headings
 * - label — inline labels and compact emphasized text
 * - overline — small uppercase labels (stat titles, eyebrows above headings)
 */
export const muiHeaderTypography = {
  overline: {
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: '1rem',
    letterSpacing: '0.025em',
    textTransform: 'uppercase',
    color: primaryTextColor,
  },
  hero: {
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    color: primaryTextColor,
  },
  title: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    color: primaryTextColor,
  },
  subtitle: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: primaryTextColor,
  },
  label: {
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: primaryTextColor,
  },
  h1: {
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    color: primaryTextColor,
  },
  h2: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    color: primaryTextColor,
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    color: primaryTextColor,
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    color: primaryTextColor,
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    color: primaryTextColor,
  },
  h6: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    color: primaryTextColor,
  },
};
